var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.84973,
    y: 1.84973,
    width: 15.2338,
    height: 21.5545,
    rx: 2.99069,
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.98456,
    y: 16.9703,
    width: 14.3198,
    height: 3.50859,
    rx: 1.7543,
    transform: "rotate(-49.8662 9.98456 16.9703)",
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 1.84043
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 6.85889H12.3383",
    stroke: "#91BDFA",
    strokeWidth: 2.30053,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard3);
export default __webpack_public_path__ + "static/media/Dashboard3.0a9586415db6a6a37cca440938ed775d.svg";
export { ForwardRef as ReactComponent };